const debug = require('debug')('client/livereload');
if (LIVERELOAD) {
    debug('livereload detected', LIVERELOAD);
    const script = document.createElement('script');
    const host = (location.host || 'localhost').split(':')[0];
    script.src = `//${host}:35729/livereload.js?snipver=1'`;
    document.body.appendChild(script);
}



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/livereload/index.ts
// module id = 659
// module chunks = 0 1 2